// Anna — replace the src values below with your own photographs.
// Everything on the site reads from this single file.
// The opening photograph (HERO_IMAGE) is the cover — it appears once, unnumbered.
// Numbered photographs (001, 002, ...) follow below it.
// wide: true marks horizontal photographs so they display larger.

export const EMAIL = "annakidman@gmail.com";

export const PRICING = "Pricing from $6500 + GST";

export const NOTICE = "Accepting select weddings for Auckland CBD only.";

export const BIO =
  "Anna Kidman lives in Auckland, New Zealand with her four children. With a previous career in editorial, she has now photographed some of the country's most beautiful weddings for over 14 years. Her work has been published on Over the Moon, The Lane, Once Wed, Magnolia Rouge, Viva and Together Journal. With a focus on portraiture, she creates timeless imagery that's filled with warmth and candour.";

export const HERO_IMAGE = {
  src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/a6ye0m8y_AKidman_Thorburn-7.webp",
    ratio: 0.7500,
  alt: "Wedding photograph",
};

export const PHOTOS = [
  {
    id: 1,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/qvkmb088_AnnaKidman_Danielle_-3.webp",
    ratio: 0.6685,
    title: "Wedding photograph I",
  },
  {
    id: 2,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/ie635a5v_AnnaKidman_Wyborn_Wedding-67.webp",
    ratio: 0.7500,
    title: "Wedding photograph II",
  },
  {
    id: 3,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/xawyv0v7_AKidman_Thorburn-5.webp",
    ratio: 0.6665,
    title: "Wedding photograph III",
  },
  {
    id: 4,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/3kobtkio_AnnaKidman_JulianaBen_Wedding-16.webp",
    ratio: 1.5004,
    title: "Wedding photograph IV",
    wide: true,
  },
  {
    id: 5,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/gz1xqz9g_AKidman_Thorburn-9.webp",
    ratio: 0.6665,
    title: "Wedding photograph V",
  },
  {
    id: 6,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/igfvl1so_AnnaKidman_ChristyandTim-105.webp",
    ratio: 1.5004,
    title: "Wedding photograph VI",
    wide: true,
  },
  {
    id: 7,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/1ziuj0is_AKidman_Thorburn-15.webp",
    ratio: 0.7500,
    title: "Wedding photograph VII",
  },
  {
    id: 8,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/gp9m5s2d_AnnaKidman_Bridget2.webp",
    ratio: 0.6665,
    title: "Wedding photograph VIII",
  },
  {
    id: 9,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/0i0e9sfd_AnnaKidman_AnnaGilbert1.webp",
    ratio: 0.7500,
    title: "Wedding photograph IX",
  },
  {
    id: 10,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/erpga82d_AnnaKidman_Mitchell_Sisler%2838of1%29.webp",
    ratio: 1.5004,
    title: "Wedding photograph X",
    wide: true,
  },
  {
    id: 11,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/4thlui7m_AnnaKidman_ChristyandTim-126.webp",
    ratio: 0.6665,
    title: "Wedding photograph XI",
  },
  {
    id: 12,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/zwi8m7vq_AnnaKidman_Angelique-2.webp",
    ratio: 0.6665,
    title: "Wedding photograph XII",
  },
  {
    id: 13,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/d6hiiyh8_AnnaKidman_JulianaBen_Preview-75.webp",
    ratio: 1.5004,
    title: "Wedding photograph XIII",
    wide: true,
  },
  {
    id: 14,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/txbeqhqt_AnnaKidman_AJD.webp",
    ratio: 0.7165,
    title: "Wedding photograph XIV",
  },
  {
    id: 15,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/jqe1xqlz_AKidman_Thorburn-39.webp",
    ratio: 0.6665,
    title: "Wedding photograph XV",
  },
  {
    id: 16,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/bi35pawe_AKidman_Thorburn-23.webp",
    ratio: 1.5004,
    title: "Wedding photograph XVI",
    wide: true,
  },
  {
    id: 17,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/319z63fs_AnnaKidman_Mitchell_Sisler%281of1%29.webp",
    ratio: 0.6665,
    title: "Wedding photograph XVII",
  },
  {
    id: 18,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/ubukl50k_AnnaKidman_Angelique-13.webp",
    ratio: 0.7500,
    title: "Wedding photograph XVIII",
  },
  {
    id: 19,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/51l2dzky_AnnaKidman_JulianaBen_Preview-86.webp",
    ratio: 1.5004,
    title: "Wedding photograph XIX",
    wide: true,
  },
  {
    id: 20,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/ivgilcas_AnnaKidman_Venter2.webp",
    ratio: 0.6665,
    title: "Wedding photograph XX",
  },
  {
    id: 21,
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_serif-showcase-5/artifacts/0dvsfd3v_AnnaKidman_Claire_Tony_Wedding-22.webp",
    ratio: 0.7500,
    title: "Wedding photograph XXI",
  },
];
